module.exports = __webpack_public_path__ + "static/media/the-good-fight-gif.ca82af55.gif";